









































































































































































































import { Component, Mixins, Ref, Prop } from "vue-property-decorator";
import { VForm } from "@/types";
import {
  OfficeItem,
  DefaultOfficeItem,
  PatientItem,
  DefaultPatientItem,
  DefaultExperimentRes,
} from "@/components/ai/types";
import {
  PromptTemplate,
  DefaultPromptTemplate,
  AiReportExperimentCondition,
  DefaultAiReportExperimentCondition,
} from "#/model/admin/index";
import ExperimentCondition from "@/components/ai/ExperimentCondition.vue";
import ExperimentConditionSelector from "@/components/ai/ExperimentConditionSelector.vue";
import ExperimentPatientSelector from "@/components/ai/ExperimentPatientSelector.vue";
import ExperimentResViewer from "@/components/ai/ExperimentResViewer.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import RulesMixin from "#/mixins/rulesMixin";
import UtilMixin from "@/mixins/utilMixin";

@Component({
  components: {
    ExperimentCondition,
    ExperimentConditionSelector,
    ExperimentPatientSelector,
    ExperimentResViewer,
  },
})
/** プロンプトテンプレートお試し */
export default class Experiment extends Mixins(
  AxiosMixin,
  RulesMixin,
  UtilMixin
) {
  /** Ref */

  /** フォーム操作用 */
  @Ref("form") protected readonly form!: VForm;

  /** 利用者選択ダイアログ制御用 */
  @Ref("experimentPatientSelector")
  protected readonly experimentPatientSelector!: ExperimentPatientSelector;

  /** お試し条件選択ダイアログ制御用 */
  @Ref("experimentConditionSelector")
  protected readonly experimentConditionSelector!: ExperimentConditionSelector;

  /** お試し結果表示ダイアログ制御用 */
  @Ref("experimentResViewer")
  protected readonly experimentResViewer!: ExperimentResViewer;

  /** Prop */

  /** プロンプトテンプレート */
  @Prop({
    default: () => {
      DefaultPromptTemplate;
    },
  })
  protected promptTemplate!: PromptTemplate;

  /** 変数 */

  /** 利用画面 1:計画書 2:報告書 */
  protected viewType = 1;

  /** iBowデータ利用フラグ */
  protected useIbowData = 1;

  /** 選択事業所データ */
  protected officeItem: OfficeItem = DefaultOfficeItem();

  /** 選択利用者データ */
  protected patientItem: PatientItem = DefaultPatientItem();

  /** お試し条件一覧データ */
  protected experimentConditions: AiReportExperimentCondition[] = [];

  /** お試し条件 */
  protected experimentCondition = DefaultAiReportExperimentCondition();

  /** お試し結果 */
  protected experimentRes = DefaultExperimentRes();

  /** コメントダイアログ制御 */
  protected commentDialog = false;

  /** 関数 */

  /** 利用者選択ダイアログを表示 */
  protected showPatientSelector() {
    this.experimentPatientSelector.open();
  }

  /** 利用者選択 */
  protected changePatient(obj: {
    officeItem: OfficeItem;
    patientItem: PatientItem;
    yearmonth: string;
  }) {
    this.postJsonCheck(
      window.base_url +
        (this.viewType == 1
          ? "/api/admin/aivnplan/patient/detail/get"
          : "/api/admin/aimonthreport/patient/detail/get"),
      {
        view_type: this.viewType,
        agreement_id: obj.officeItem.agreement_id,
        patient_id: obj.patientItem.patient_id,
        yearmonth: obj.yearmonth,
      },
      (res) => {
        this.officeItem = { ...obj.officeItem };
        this.patientItem = { ...res.data.patient_item };
        this.experimentCondition = {
          id: 0,
          type: this.viewType,
          agreement_id: this.officeItem.agreement_id,
          office_id: this.officeItem.office_id,
          patient_id: this.patientItem.patient_id,
          co_code: this.officeItem.co_code,
          co_name: this.officeItem.co_name,
          kst_no: this.officeItem.kst_no,
          office_name: this.officeItem.office_name,
          patient_name: this.patientItem.patient_name,
          comment: "",
          option: {
            yearmonth: obj.yearmonth,
            use_vital: 0,
            use_observation: 0,
            use_vn_record_fam: 0,
          },
          editor_admin_id: 0,
          created_at: "",
          updated_at: "",
          deleted_at: "",
        };

        this.experimentPatientSelector.close();
      }
    );
  }

  /** お試し条件ダイアログ開く */
  protected showExperimentConditionSelector() {
    this.experimentConditionSelector.open();
  }

  /** お試し条件選択 */
  protected changeExperimentCondition(item: AiReportExperimentCondition) {
    this.postJsonCheck(
      window.base_url +
        (this.viewType == 1
          ? "/api/admin/aivnplan/patient/detail/get"
          : "/api/admin/aimonthreport/patient/detail/get"),
      {
        view_type: this.viewType,
        agreement_id: item.agreement_id,
        patient_id: item.patient_id,
        yearmonth: item.option.yearmonth,
      },
      (res) => {
        this.patientItem = res.data.patient_item;
        this.officeItem = {
          agreement_id: item.agreement_id,
          co_code: item.co_code,
          co_name: item.co_name,
          office_id: item.office_id,
          kst_no: item.kst_no,
          office_name: item.office_name,
          office_div: 0,
        };
        this.experimentCondition = { ...item };
        this.experimentCondition.comment = "";
        this.experimentConditionSelector.close();
      }
    );
  }

  /** お試しボタン押下時 */
  protected async beforeExperiment() {
    //
  }

  /** お試し */
  protected experiment() {
    //
  }

  /** お試し条件保存前 */
  protected beforeSaveExperimentCondition() {
    this.commentDialog = true;
  }

  /** お試し条件保存キャンセル */
  protected cancelSaveExperimentCondition() {
    this.commentDialog = false;
    this.experimentCondition.comment = "";
  }

  /** お試し条件保存 */
  protected saveExperimentCondition() {
    this.experimentCondition.id = 0;
    this.experimentCondition.type = this.viewType;

    this.postJsonCheck(
      window.base_url +
        (this.viewType == 1
          ? "/api/admin/aivnplan/experiment_condition/save"
          : "/api/admin/aimonthreport/experiment_condition/save"),
      {
        experiment_condition: this.experimentCondition,
      },
      () => {
        this.commentDialog = false;
        this.experimentCondition.comment = "";
        this.fetchExperimentCondition();
      }
    );
  }

  /** お試し条件削除 */
  protected deleteExperimentCondition(item: AiReportExperimentCondition) {
    this.postJsonCheck(
      window.base_url +
        (this.viewType == 1
          ? "/api/admin/aivnplan/experiment_condition/delete"
          : "/api/admin/aimonthreport/experiment_condition/delete"),
      {
        experiment_condition: item,
      },
      () => {
        this.fetchExperimentCondition();
      }
    );
  }

  /** プロンプトお試し条件取得 */
  protected fetchExperimentCondition() {
    this.postJsonCheck(
      window.base_url +
        (this.viewType == 1
          ? "/api/admin/aivnplan/experiment_condition/get"
          : "/api/admin/aimonthreport/experiment_condition/get"),
      {
        type: this.viewType,
      },
      async (res) => {
        this.experimentConditions = res.data.experiment_conditions;
      }
    );
  }

  /** 当月取得 */
  protected getCurrentYearmonth() {
    return this.dateToStr(new Date(), "yyyy-MM");
  }
}
